export default {"src":"/_next/static/media/adx.d19c5a3a.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};